import React from 'react';
import SvgIcon from '../../images/ilustrations/Anye_Grillete_esposas_new.svg';

const AnyeEsposas = () => (
    <img src={SvgIcon} alt="Esposas" style={{ width: '1.5em', height: '1.5em' }} />
);

export default AnyeEsposas;
